export const names = [
    null,
    "CIENCIAS AGRICOLAS",
    "CIENCIAS NATURALES",
    "MEDICINA Y CIENCIAS DE LA SALUD",
    "CIENCIAS SOCIALES",
    "INGENIERIA Y TECNOLOGIA",
    "HUMANIDADES",
    null,
    "CIENCIAS VETERINARIAS",
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    "MEDICINA CLINICA",
    null,
    "PSICOLOGIA",
    "ECONOMIA Y NEGOCIOS",
    "CIENCIAS DE LA EDUCACION",
    null,
    null,
    null,
    null,
    "CIENCIAS POLITICAS",
    null,
    null,
    "INGENIERIA CIVIL",
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    "ETICA",
    "TEOLOGIA",
    "ARTE (ARTES, HISTORIA DEL ARTE, ARTES ESCENICAS, MUSICA)",
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    "AGRICULTURA, SILVICULTURA, PESCA",
    "CIENCIA ANIMAL Y LECHERIA",
    "BIOTECNOLOGIA AGRICOLA",
    "OTRAS CIENCIAS AGRICOLAS",
    "MATEMATICAS",
    "CIENCIAS DE LA INFORMACION Y COMPUTACION",
    "CIENCIAS FISICAS",
    "CIENCIAS QUIMICAS",
    "CIENCIAS DE LA TIERRA Y DEL MEDIO AMBIENTE",
    "CIENCIAS BIOLOGICAS",
    "OTRAS CIENCIAS NATURALES",
    "MEDICINA BASICA",
    "CIENCIAS DE LA SALUD",
    "BIOTECNOLOGIA MEDICA",
    "OTRAS CIENCIAS MEDICAS",
    "SOCIOLOGIA",
    "DERECHO",
    "GEOGRAFIA ECONOMICA Y SOCIAL",
    "COMUNICACION Y MEDIOS",
    "OTRAS CIENCIAS SOCIALES",
    "INGENIERIA ELECTRICA, INGENIERIA ELECTRONICA, INFORMATICA",
    "INGENIERIA MECANICA",
    "INGENIERIA QUIMICA",
    "INGENIERIA DE LOS MATERIALES",
    "INGENIERIA MEDICA",
    "INGENIERIA AMBIENTAL",
    "BIOTECNOLOGIA AMBIENTAL",
    "BIOTECNOLOGIA INDUSTRIAL",
    "NANOTECNOLOGIA",
    "OTRAS INGENIERIAS Y TECNOLOGIAS",
    "HISTORIA Y ARQUEOLOGIA",
    "LENGUAJE Y LITERATURA",
    "FILOSOFIA, ETICA Y RELIGION",
    "OTRAS HUMANIDADES",
    "MATEMATICAS PURAS",
    "MATEMATICAS APLICADAS",
    "ESTADISTICAS Y PROBABILIDADES",
    "OTRAS ESPECIALIDADES DE LAS MATEMATICAS",
    "CIENCIAS DE LA COMPUTACION",
    "CIENCIAS DE LA INFORMACION Y BIOINFORMATICA",
    "OTRAS ESPECIALIDADES DE LAS CIENCIAS DE LA INFORMACION Y COMPUTACION",
    "FISICA ATOMICA, MOLECULAR Y QUIMICA",
    "FISICA DE LA MATERIA CONDENSADA",
    "FISICA DE PARTICULAS Y CAMPOS",
    "FISICA NUCLEAR",
    "FISICA DE PLASMAS Y FLUIDOS",
    "OPTICA",
    "ACUSTICA",
    "ASTRONOMIA",
    "OTRAS ESPECIALIDADES DE LA FISICA",
    "QUIMICA ORGANICA",
    "QUIMICA INORGANICA Y NUCLEAR",
    "FISICO-QUIMICA",
    "POLIMEROS",
    "ELECTROQUIMICA",
    "QUIMICA DE LOS COLOIDES",
    "QUIMICA ANALITICA",
    "OTRAS ESPECIALIDADES DE LA QUIMICA",
    "GEOCIENCIAS",
    "MINERALOGIA",
    "PALEONTOLOGIA",
    "GEOQUIMICA Y GEOFISICA",
    "GEOGRAFIA FISICA",
    "GEOLOGIA",
    "VULCANOLOGIA",
    "CIENCIAS DEL MEDIO AMBIENTE",
    "METEOROLOGIA Y CIENCIAS ATMOSFERICAS",
    "CLIMATOLOGIA",
    "OCEANOGRAFIA, HIDROLOGIA Y RECURSOS DEL AGUA",
    "OTRAS ESPECIALIDADES DE CIENCIAS DE LA TIERRA",
    "BIOLOGIA CELULAR",
    "MICROBIOLOGIA",
    "VIROLOGIA",
    "BIOQUIMICA",
    "BIOLOGIA MOLECULAR",
    "METODOS DE INVESTIGACION EN BIOQUIMICA",
    "MICOLOGIA",
    "BIOFISICA",
    "GENETICA Y HERENCIA",
    "BIOLOGIA REPRODUCTIVA",
    "BIOLOGIA DEL DESARROLLO",
    "BOTANICA",
    "ZOOLOGIA, ORNITOLOGIA, ENTOMOLOGIA, COMPORTAMIENTO BIOLOGICO",
    "BIOLOGIA MARINA, LIMNOLOGIA",
    "ECOLOGIA",
    "CONSERVACION DE LA BIODIVERSIDAD",
    "BIOLOGIA (TEORICA, MATEMATICA, CRIOBIOLOGIA, RITMOS BIOLOGICOS)",
    "BIOLOGIA EVOLUTIVA",
    "OTRAS ESPECIALIDADES DE LA BIOLOGIA",
    "INGENIERIA CIVIL",
    "INGENIERIA ARQUITECTONICA",
    "INGENIERIA DE LA CONSTRUCCION",
    "INGENIERIA ESTRUCTURAL Y MUNICIPAL",
    "INGENIERIA DE TRANSPORTE",
    "INGENIERIA ELECTRICA Y ELECTRONICA",
    "ROBOTICA Y SISTEMAS DE CONTROL AUTOMATICO",
    "SISTEMAS DE AUTOMATIZACION Y CONTROL",
    "INGENIERIA DE SISTEMAS Y COMUNICACIONES",
    "TELECOMUNICACIONES",
    "ARQUITECTURA Y HARDWARE DE COMPUTACION",
    "INGENIERIA MECANICA",
    "MECANICA APLICADA",
    "TERMODINAMICA",
    "INGENIERIA AEROESPACIAL",
    "INGENIERIA NUCLEAR",
    "INGENIERIA DE AUDIO O INGENIERIA EN SONIDO",
    "INGENIERIA QUIMICA",
    "INGENIERIA DE PROCESOS QUIMICOS",
    "INGENIERIA DE LOS MATERIALES",
    "CERAMICOS",
    "RECUBRIMIENTOS Y PELICULAS",
    "COMPUESTOS (LAMINADOS, PLASTICOS REFORZADOS, FRIBRAS SINTETICAS Y NATURALES)",
    "PAPEL Y MADERA",
    "TEXTILES",
    "INGENIERIA MEDICA",
    "TECNOLOGIA MEDICA",
    "INGENIERIA AMBIENTAL Y GEOLOGICA",
    "GEOTECNIA",
    "INGENIERIA DEL PETROLEO (COMBUSTIBLES Y ACEITES)",
    "SENSORES REMOTOS",
    "MINERIA Y PROCESAMIENTO DE MINERALES",
    "INGENIERIA MARINA Y NAVAL",
    "INGENIERIA OCEANOGRAFICA",
    "BIOTECNOLOGIA AMBIENTAL",
    "BIORREMEDIACION",
    "BIOTECNOLOGIA DE DIAGNOSTICO (CHIPS DE ADN Y DISPOSITIVOS BIOSENSORES) EN MANEJO AMBIENTAL",
    "ETICA RELACIONADA CON BIOTECNOLOGIA AMBIENTAL",
    "BIOTECNOLOGIA INDUSTRIAL",
    "TECNOLOGIAS DE BIOPROCESAMIENTO, BIOCATALISIS, FERMENTACION",
    "BIOPRODUCTOS (PRODUCTOS QUE SE MANUFACTURAN USANDO BIOTECNOLOGIA COMO MATERIA PRIMA), BIOMATERIALES, BIOPLASTICOS, BIOCOMBUSTIBLES, QUIMICOS BRUTOS Y FINOS BIODERIVADOS, MATERIALES NUEVOS BIODERIVADOS",
    "NANOMATERIALES (PRODUCCION Y PROPIEDADES)",
    "NANOPROCESOS (APLICACIONES A NANOESCALA)",
    "TECNOLOGIA DE LOS ALIMENTOS",
    "OTRAS INGENIERIAS Y TECNOLOGIAS",
    "ANATOMIA Y MORFOLOGIA",
    "GENETICA HUMANA",
    "INMUNOLOGIA",
    "NEUROCIENCIAS",
    "FARMACOLOGIA Y FARMACIA",
    "QUIMICA MEDICA",
    "TOXICOLOGIA",
    "FISIOLOGIA",
    "PATOLOGIA",
    "OTROS TEMAS DE MEDICINA BASICA",
    "ANDROLOGIA",
    "OBSTETRICIA Y GINECOLOGIA",
    "PEDIATRIA",
    "SISTEMA CARDIOVASCULAR Y CARDIACO",
    "ENFERMEDADES VASCULARES PERIFERICAS",
    "HEMATOLOGIA",
    "SISTEMA RESPIRATORIO",
    "MEDICINA DE EMERGENCIA Y DE CUIDADOS CRITICOS",
    "ANESTESIOLOGIA",
    "ORTOPEDIA",
    "CIRUGIA",
    "RADIOLOGIA, MEDICINA NUCLEAR Y DE IMAGENES",
    "TRANSPLANTES",
    "ODONTOLOGIA, CIRUGIA Y MEDICINA ORAL",
    "DERMATOLOGIA Y ENFERMEDADES VENEREAS",
    "ALERGIAS",
    "REUMATOLOGIA",
    "ENDOCRINOLOGIA Y METABOLISMO (INCLUYE DIABETES, HORMONAS)",
    "GASTROENTEROLOGIA Y HEPATOLOGIA",
    "UROLOGIA Y NEFROLOGIA",
    "ONCOLOGIA",
    "OFTALMOLOGIA",
    "OTORRINOLARINGOLOGIA",
    "PSIQUIATRIA",
    "NEUROLOGIA CLINICA",
    "GERIATRIA Y GERONTOLOGIA",
    "MEDICINA GENERAL E INTERNA",
    "OTROS TEMAS DE MEDICINA CLINICA",
    "MEDICINA INTEGRATIVA Y COMPLEMENTARIA (SISTEMAS DE PRACTICA ALTERNATIVA)",
    "SERVICIOS Y CUIDADOS EN CIENCIAS DE LA SALUD (ADMINISTRACION DE HOSPITALES, FINANCIAMIENTO DE LA ATENCION HOSPITALARIA)",
    "POLITICAS DE SALUD Y SERVICIOS",
    "ENFERMERIA",
    "NUTRICION, DIETETICA",
    "SALUD PUBLICA Y AMBIENTAL",
    "MEDICINA TROPICAL",
    "PARASITOLOGIA",
    "ENFERMEDADES INFECCIOSAS",
    "EPIDEMIOLOGIA",
    "SALUD OCUPACIONAL",
    "CIENCIAS DEL DEPORTE Y ACONDICIONAMIENTO FISICO",
    "CIENCIAS SOCIALES BIOMEDICAS (INCLUYE, PLANIFICACION FAMILIAR, SALUD SEXUAL, PSICOLOGIA ONCOLOGICA, EFECTOS POLITICOS Y SOCIALES DE LA INVESTIGACION BIOMEDICA)",
    "ETICA MEDICA",
    "ABUSO DE SUBSTANCIAS",
    "BIOTECNOLOGIA RELACIONADA CON LA SALUD",
    "TECNOLOGIAS QUE INVOLUCRAN LA MANIPULACION DE CELULAS, TEJIDOS, ORGANOS O EL ORGANISMO COMPLETO (REPRODUCCION ASISTIDA)",
    "TECNOLOGIA PARA LA IDENTIFICACION Y FUNCIONAMIENTO DEL ADN, PROTEINAS Y ENZIMAS Y COMO INFLUYEN EN LA APARICION DE ENFERMEDADES Y LA MANTENCION DEL BIENESTAR (DIAGNOSTICO E INTERVENCIONES TERAPEUTICAS BASADOS EN GENES (FARMACOGENOMICA, TERAPIAS BASADAS EN",
    "BIOMATERIALES (RELACIONADOS CON IMPLANTES MEDICOS, DISPOSITIVOS Y SENSORES)",
    "BIOTECNOLOGIA MEDICA RELACIONADA CON LA ETICA",
    "CIENCIA FORENSE",
    "OTRAS CIENCIAS MEDICAS",
    "AGRICULTURA",
    "SILVICULTURA",
    "PESCA",
    "CIENCIAS DEL SUELO",
    "HORTICULTURA",
    "VITICULTURA",
    "AGRONOMIA",
    "FITOMEJORAMIENTO Y PROTECCION VEGETAL",
    "CIENCIA ANIMAL Y LECHERIA",
    "GANADERIA",
    "ANIMALES DOMESTICOS",
    "BIOTECNOLOGIA AGRICOLA",
    "BIOTECNOLOGIA AGRICOLA Y BIOTECNOLOGIA ALIMENTARIA",
    "TECNOLOGIA DE MODIFICACION GENETICA",
    "BIOTECNOLOGIA AGRICOLA RELACIONADA CON LA ETICA",
    "PSICOLOGIA (INCLUYENDO LA RELACION HOMBRE-MAQUINA)",
    "PSICOLOGIA, ESPECIAL (INCLUYE TERAPIAS DE APRENDIZAJE, LENGUAJE, AUDICION, VISION Y OTRAS DISCAPACIDADES FISICAS Y MENTALES)",
    "OTRAS ESPECIALIDADES DE LA PSICOLOGIA",
    "ECONOMIA",
    "ECONOMETRIA",
    "RELACIONES INDUSTRIALES",
    "ADMINISTRACION Y NEGOCIOS",
    "OTRAS ESPECIALIDADES DE LA ECONOMIA",
    "EDUCACION GENERAL",
    "EDUCACION ESPECIAL",
    "OTRAS ESPECIALIDADES DE LA EDUCACION",
    "SOCIOLOGIA",
    "DEMOGRAFIA",
    "ETNOLOGIA",
    "OTRAS ESPECIALIDADES DE LA SOCIOLOGIA",
    "ANTROPOLOGIA",
    null,
    "DERECHO",
    "DERECHO PENAL",
    "CRIMINOLOGIA",
    "OTRAS ESPECIALIDADES DEL DERECHO",
    "CIENCIAS POLITICAS",
    "ADMINISTRACION PUBLICA",
    "TEORIA ORGANIZACIONAL",
    "OTRAS ESPECIALIDADES DE LAS CIENCIAS POLITICAS",
    "CIENCIAS AMBIENTALES (ASPECTOS SOCIALES)",
    "GEOGRAFIA CULTURAL Y ECONOMICA",
    "URBANISMO",
    "PLANIFICACION DEL TRANSPORTE Y ASPECTOS SOCIALES DEL TRANSPORTE",
    "OTRAS ESPECIALIDADES DE LA GEOGRAFIA ECONOMICA Y SOCIAL",
    "PERIODISMO",
    "CIENCIAS DE LA INFORMACION (ASPECTOS SOCIALES)",
    "BIBLIOTECOLOGIA",
    "MEDIOS DE COMUNICACION SOCIO-CULTURAL",
    "OTRAS ESPECIALIDADES DE COMUNICACION Y MEDIOS",
    "CIENCIAS SOCIALES, INTERDISCIPLINARIA",
    "OTRAS CIENCIAS SOCIALES",
    "HISTORIA",
    "ARQUEOLOGIA",
    "HISTORIA DE CHILE",
    "OTRAS ESPECIALIDADES DE LA HISTORIA Y LA ARQUEOLOGIA",
    "ESTUDIOS GENERALES DEL LENGUAJE",
    "LENGUAJES ESPECIFICOS",
    "ESTUDIOS GENERALES DE LA LITERATURA",
    "TEORIA LITERARIA",
    null,
    null,
    "OTRAS ESPECIALIDADES DEL LENGUAGE Y LA LITERATURA",
    "FILOSOFIA",
    "ANTROPOLOGIA",
    "OTRAS ESPECIALIDADES DE LA  ANTROPOLOGIA",
    "ESTUDIOS RELIGIOSOS",
    "OTRAS ESPECIALIDADES DE LA FILOSOFIA, ETICA Y RELIGION",
    "ARTE",
    "HISTORIA DEL ARTE",
    "DISEÑO ARQUITECTONICO",
    "ARTES DE LA REPRESENTACION (MUSICOLOGIA, TEATRO, DRAMATURGIA)",
    "ESTUDIOS DEL FOLCLORE",
    "ESTUDIOS DE CINE, RADIO Y TELEVISION",
    "OTRAS ESPECIALIDADES DEL ARTE"
]

export const parents = [
    [
        1,
        2,
        4,
        6,
        5,
        3
    ],
    [
        58,
        60,
        59,
        8,
        61
    ],
    [
        67,
        63,
        66,
        64,
        65,
        62,
        68
    ],
    [
        71,
        70,
        69,
        20,
        72
    ],
    [
        282,
        24,
        29,
        76,
        74,
        23,
        75,
        77,
        22,
        73
    ],
    [
        84,
        85,
        83,
        32,
        81,
        78,
        79,
        82,
        80,
        86,
        87
    ],
    [
        49,
        90,
        88,
        89,
        91
    ],
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    [
        217,
        202,
        210,
        212,
        216,
        219,
        206,
        220,
        227,
        207,
        209,
        228,
        230,
        226,
        203,
        215,
        223,
        222,
        211,
        224,
        229,
        204,
        225,
        213,
        218,
        205,
        208,
        214,
        221
    ],
    null,
    [
        269,
        267,
        268
    ],
    [
        273,
        271,
        270,
        274,
        272
    ],
    [
        276,
        275,
        277
    ],
    null,
    null,
    null,
    null,
    [
        289,
        288,
        291,
        290
    ],
    null,
    null,
    [
        148,
        147,
        149,
        151,
        150
    ],
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    [
        320,
        323,
        322,
        325,
        324,
        321,
        326
    ],
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    [
        252,
        258,
        255,
        259,
        256,
        254,
        253,
        257
    ],
    [
        262,
        260,
        261
    ],
    [
        263,
        266,
        264,
        265
    ],
    null,
    [
        94,
        93,
        92,
        95
    ],
    [
        96,
        97,
        98
    ],
    [
        105,
        106,
        99,
        100,
        101,
        103,
        102,
        104,
        107
    ],
    [
        112,
        110,
        115,
        111,
        114,
        113,
        109,
        108
    ],
    [
        123,
        125,
        116,
        120,
        121,
        119,
        124,
        117,
        126,
        127,
        118,
        122
    ],
    [
        135,
        144,
        128,
        138,
        145,
        141,
        132,
        137,
        131,
        139,
        143,
        142,
        136,
        133,
        134,
        129,
        146,
        130,
        140
    ],
    null,
    [
        192,
        196,
        199,
        193,
        194,
        195,
        201,
        200,
        197,
        198
    ],
    [
        244,
        241,
        242,
        238,
        233,
        239,
        243,
        236,
        234,
        237,
        232,
        240,
        235,
        231
    ],
    [
        248,
        249,
        245,
        247,
        246
    ],
    [
        250,
        251
    ],
    [
        279,
        280,
        281,
        278
    ],
    [
        286,
        284,
        285,
        287
    ],
    [
        292,
        293,
        296,
        295,
        294
    ],
    [
        299,
        298,
        300,
        301,
        297
    ],
    [
        302,
        303
    ],
    [
        157,
        155,
        152,
        153,
        154,
        156
    ],
    [
        161,
        163,
        158,
        162,
        159,
        160
    ],
    [
        165,
        164
    ],
    [
        167,
        169,
        166,
        170,
        168,
        171
    ],
    [
        172,
        173
    ],
    [
        175,
        174,
        176,
        179,
        180,
        178,
        177
    ],
    [
        182,
        181,
        183,
        184
    ],
    [
        187,
        185,
        186
    ],
    [
        188,
        189
    ],
    [
        191,
        190
    ],
    [
        305,
        304,
        306,
        307
    ],
    [
        310,
        308,
        309,
        314,
        311
    ],
    [
        318,
        47,
        315,
        319,
        48
    ],
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    [
        316,
        317
    ]
]

// Get the main OCDE areas (level 1)
export const getOcdeAreas = () => {
  const areaIndices = [1, 2, 4, 6, 5, 3]; // Main areas
  return areaIndices.map(index => ({
    id: index,
    name: names[index]
  })).filter(area => area.name);
};

// Get subareas for a given area (level 2)  
export const getOcdeSubareas = (areaIndex) => {
  const subareaIndices = parents[areaIndex];
  if (!subareaIndices) return [];
  
  return subareaIndices.map(index => ({
    id: index,
    name: names[index]
  })).filter(subarea => subarea.name);
};

// Get disciplines for a given subarea (level 3)
export const getOcdeDisciplines = (subareaIndex) => {
  const disciplineIndices = parents[subareaIndex];
  if (!disciplineIndices) return [];
  
  return disciplineIndices.map(index => ({
    id: index,
    name: names[index]
  })).filter(discipline => discipline.name);
};